(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[231],{

/***/ 5575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[site]/about",
      function () {
        return __webpack_require__(81);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(260);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3825);
/* harmony import */ var components_WordpressSEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1610);
/* harmony import */ var components_Blocks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4512);
/* harmony import */ var _about_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8574);
/* harmony import */ var _about_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_about_module_css__WEBPACK_IMPORTED_MODULE_7__);









//TODO: Add proptypes
function About(param) {
    var acfBlocks = param.acfBlocks, site = param.site, globalSettings = param.globalSettings;
    var state = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_3__/* .GlobalStateContext */ .Pn);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        globalSettings: globalSettings,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_WordpressSEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: "/".concat(site, "/about"),
                title: "About"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_about_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
                children: acfBlocks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Blocks__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    postType: "Page",
                    children: acfBlocks
                })
            })
        ]
    });
}
About.propTypes = {
    globalSettings: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object)
};
About.defaultProps = {
    globalSettings: {}
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (About);


/***/ }),

/***/ 8574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"spacing--xxxs":"about_spacing--xxxs__YJ66H","spacing--xxs":"about_spacing--xxs__iWiAI","spacing--xs":"about_spacing--xs__1mO59","spacing--sm":"about_spacing--sm__Ce12e","spacing--md":"about_spacing--md__7zuth","spacing--lg":"about_spacing--lg__XRkEu","spacing--xl":"about_spacing--xl__NiC32","spacing--xxl":"about_spacing--xxl__p9_qd","spacing--xxxl":"about_spacing--xxxl__8btSe","container":"about_container__53s4P","fadeInItems":"about_fadeInItems__P3_mx"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [333,216,66,529,895,774,888,179], function() { return __webpack_exec__(5575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);